<template>
  <div class="spinner">
    <div class="loading-spin"></div>
    <p v-if="this.showText">
      <small>{{ $t("loading") }}</small>
    </p>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import VueI18n from "vue-i18n";

export default {
  name: "Spinner",
  mixins: [LocaleMixin],
  props: {
    showText: {
      type: Boolean,
      default: true
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        loading: "loading ..."
      },
      fr: {
        loading: "chargement ..."
      }
    }
  })
};
</script>

<style lang="scss">
@import "../../assets/styles/variables.scss";

.spinner {
  text-align: center;
  padding-top: 2em;
  .loading-spin {
    display: inline-block;
    z-index: 99;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    content: "";
    font-size: 10px;
    text-indent: -9999em;
    border-top: 3px solid rgba(0, 0, 0, 0.1) !important;
    border-right: 3px solid rgba(0, 0, 0, 0.1) !important;
    border-bottom: 3px solid rgba(0, 0, 0, 0.1) !important;
    opacity: 0.8;
    border-left: 3px solid #446084;
    animation: spin 0.6s infinite linear;
    pointer-events: none;
    box-sizing: border-box;
  }

  p {
    margin-top: 0;
    text-align: center;
    small {
      color: $grey;
    }
  }
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
